import { Box } from "@mui/material";

import { BodyText, CaptionText } from "~/components/Typographies";

interface ProfileValueTileProps {
	label: string;
	mono?: boolean;
	value: string;
}

const ProfileValueTile = ({ label, mono = false, value }: ProfileValueTileProps) => (
	<Box sx={{ bgcolor: "action.hover", borderRadius: 2, maxWidth: "100%", minWidth: 0, px: 2, py: 1.25 }}>
		<CaptionText
			sx={{ color: "text.secondary", display: "block", letterSpacing: "0.08em", textTransform: "uppercase" }}
		>
			{label}
		</CaptionText>
		<BodyText bold sx={{ fontFamily: mono ? "monospace" : undefined, wordBreak: "break-all" }}>
			{value}
		</BodyText>
	</Box>
);

export default ProfileValueTile;
